
/* injects from baggage-loader */

'use strict';

import './footer.scss';
import footerDirective from './footer.directive';

/**
 * Footer module definition.
 */
const footerModule = angular.module('footer.module', []);

footerModule
  .directive('appFooter', footerDirective);

export default footerModule;



// WEBPACK FOOTER //
// ./src/app/core/components/footer/footer.module.js